import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"
import { Observable } from "rxjs"
import { APIResponse } from "shared/models/api-response"

@Injectable({
    providedIn: 'root'
})
export class PlannerEventsApiService {

    constructor(private http: HttpClient) { }

    public create(data: any): Observable<APIResponse> {
        return this.http.post<APIResponse>(API_HOST + 'planner-events', data)
    }

    public update(id: string, data: any): Observable<APIResponse> {
        return this.http.put<APIResponse>(API_HOST + `planner-events/${id}`, data)
    }

    public delete(id: string): Observable<APIResponse> {
        return this.http.delete<APIResponse>(API_HOST + `planner-events/${id}`)
    }

    public get(): Observable<APIResponse> {
        return this.http.get<APIResponse>(API_HOST + 'planner-events')
    }
}
